module.exports = __webpack_public_path__ + "media/images/icons/material/people-3dc7b1256c1f0fb82c576e093f225cc5.svg";